import React, {useState} from "react";

import style from "../assets/styles/style.module.scss";
import "../assets/styles/open-iconic.css";
import classes from "./NavBar.module.scss";

function NavBar() {
     const [menuClass, setMenuClass] = useState(classes.menu);

     function expand(){
         if(menuClass === classes.menu){
             setMenuClass(`${classes.menu} ${classes.expanded}`);
         } else {
             setMenuClass(classes.menu);
         }

     }
    return (<div className={classes.Navbar}>
        <nav>
            <div className={`${style.container} ${classes.navContainer}`}>
                <a href="#" className={classes.navBrand}>CASA KOTYS</a>
                <button className={classes.menuBtn} onClick={() =>{expand()}}>
                    <span className="oi oi-menu"></span> Menu
                </button>
                {/*<div className={classes.menuOuter}>*/}
                    <ul className={menuClass}>
                        <li><a href="#">Home</a></li>
                        <li><a href="#">Rooms</a></li>
                        <li><a href="#">Activities</a></li>
                        <li><a href="#">Contact</a></li>
                    </ul>
                {/*</div>*/}
            </div>
        </nav>
    </div>);
}

export default NavBar;
